import { get } from 'lodash/fp'
import styled from 'styled-components'
import VALUES from 'core/data-model/constants/values'
import _ from 'lodash'
import React from 'react'
import { useSelector } from 'react-redux'
import { getCurrentApp } from 'e-submission/apps/selectors'
import {
  getLuckyNumberOptions,
  getLuckyNumberStatus,
  getSelectedLuckyNumber,
} from 'e-submission/domain/data-model/form/selectors'
import { ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap'
import { Modal } from 'common-components/index'
import FormSection from 'e-submission/components/Layout/FormSection'
import FormContent from 'e-submission/components/Layout/FormContent'
import IconLuckyNumber from 'assets/images/nav/icon-lucky-number.svg'
import LuckyNumberValidation from 'e-submission/containers/AppForm/FormValidation/luckyNumberValidation'

const ModalTitleSection = styled(ModalHeader)`
  .close {
    margin-top: -8px;
  }
  .modal-title {
    width: 100%;
  }
  .modal-header-sub-title {
    text-align: center;
    font-weight: bold;
    display: block;
    color: ${({ theme }) => theme.variables['$brand-primary']};
    margin-left: 16.5px;
  }
`

const CheckBox = styled.div`
  width: 20px;
  height: 20px;
  margin-top: 2px;
  &::before {
    content: '';
    background-color: ${({ disabled }) => (disabled ? '#eceeef' : 'white')};
    width: 20px;
    height: 20px;
    border: 1px solid #ccc;
    display: inline-block;
    border-radius: 20px;
    position: relative;
  }
  &::after {
    content: '';
    background-color: ${({ disabled }) => (disabled ? '#eceeef' : 'white')};
    width: 10px;
    height: 10px;
    display: inline-block;
    border-radius: 20px;
    position: relative;
    top: -33.75px;
    left: 5px;
  }
  &.active::after {
    background-color: ${VALUES.PRIMARY_COLOR};
  }
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`

const RadioWrapper = styled.div`
  justify-content: start;
  flex: 1 1 50%;
  display: flex;
  font-size: 24px;
  color: ${({ disabled }) => (disabled ? '#999' : '#2425aa')};
  align-items: flex-start;
  padding: 8px 10px 8px 0px;
  &:last-child {
    margin-bottom: -1px;
  }
  label {
    margin-bottom: 0;
  }
`
const Content = styled.div`
  flex: 1;
  margin-left: 10px;
`

export const Radio = ({ option, active, onClick, disabled }) => {
  const word = option?.policyNumber ?? 'undefined'
  return (
    <RadioWrapper className={['radio-item', active ? 'active' : ''].join(' ')} disabled={disabled}>
      <CheckBox
        className={active ? 'active' : ''}
        disabled={disabled}
        onClick={(e) => {
          e.preventDefault()
          onClick(option)
        }}
      />
      <Content disabled={disabled}>{`${word.slice(0, 7)} ${word.slice(7)}`}</Content>
    </RadioWrapper>
  )
}

const RadioGroupWrapper = styled.div`
  .radio-group,
  radio-group-border-top {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .radio-group-border-top {
    border-top: ;
  }
`

const ShowNumbersTitle = styled.div`
  margin-bottom: 10px;

  .title {
    label {
      align-items: center;
      display: flex;
      height: 32px;
    }
  }

  .title-text {
    font-size: 1.325rem;
    color: #2425aa;
    font-weight: bold;
  }
`

const Border = styled.div`
  height: 1px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin: 10px 0 !important;
`

const CompleteMessage = styled.div`
  width: 100%;
  text-align: center;
  img,
  svg {
    width: 160px;
    margin-bottom: 1rem;
    margin-top: -2rem;
  }
  iframe {
    width: 100%;
    height: 1024px;
  }
`

const displayCompleteMessage = (selectedLuckyNumber) => {
  // const word = selectedLuckyNumber.policyNumber ?? 'undefined'
  const objMessageConfirm = (
    <FormContent>
      <img src={IconLuckyNumber} alt="img-nav" />
      <FormContent>
        ขอแสดงความยินดีท่านได้ทำการจองหมายเลขกรมธรรม์ได้สำเร็จ
        <br />
        กรุณาดำเนินการนำส่งใบคำขอภายใน 30 วัน มิเช่นนั้นบริษัทจะถือว่าท่านสละสิทธิ์
        {/* หมายเลขที่ท่านเลือกคือ {`${word.slice(0, 7)} ${word.slice(7)}`} */}
      </FormContent>
    </FormContent>
  )

  return (
    <FormSection>
      <FormContent>{objMessageConfirm}</FormContent>
    </FormSection>
  )
}

const LuckyNumberRadioGroup = ({ disabled, value, setValue, setUsedLuckyNumberModal }) => {
  const state = useSelector((state) => state)
  const app = getCurrentApp(state)
  const luckyNumberOptions = getLuckyNumberOptions(app)
  const luckyNumberStatus = getLuckyNumberStatus(app)
  const selectedLuckyNumber = getSelectedLuckyNumber(app)

  const isUsedLuckyNumberModal = _.get(state, `ui.isUsedLuckyNumberModal`)

  const groupItems = (items) => {
    if (items.length > 10) {
      return [items.slice(0, 10), items.slice(10)]
    }
    return [items]
  }

  return (
    <>
      <LuckyNumberValidation />
      {luckyNumberStatus ? (
        <CompleteMessage>{displayCompleteMessage(selectedLuckyNumber)}</CompleteMessage>
      ) : luckyNumberOptions ? (
        <>
          <ShowNumbersTitle>
            <div className="title">
              <span className="title-text">ผลการค้นหาตัวเลข</span>
              {luckyNumberOptions.length ? (
                <label>{luckyNumberOptions.length} ชุดตัวเลขที่เหมาะสมกับท่าน</label>
              ) : (
                <label>ไม่พบหมายเลขที่ท่านต้องการ</label>
              )}
            </div>
          </ShowNumbersTitle>
          <RadioGroupWrapper>
            {groupItems(luckyNumberOptions).map((group, groupIndex) => (
              <>
                {groupIndex === 1 && <Border />}
                <div key={groupIndex} className="radio-group">
                  {group.map((option, index) => (
                    <Radio
                      className="radio-item-option"
                      key={`${index}-${option.id}`}
                      onClick={option.disabled ? () => {} : setValue}
                      option={option}
                      active={get('id')(option) === value}
                      disabled={option.disabled}
                    />
                  ))}
                </div>
              </>
            ))}
          </RadioGroupWrapper>
          <Modal
            id="used-lucky-number-modal"
            className={'used-lucky-number-modal'}
            isOpen={isUsedLuckyNumberModal}
            size="md"
            modalClassName="default-bootstrap"
            toggle={() => setUsedLuckyNumberModal(false)}
          >
            <ModalTitleSection tag="div" toggle={() => setUsedLuckyNumberModal(false)}>
              <span className="modal-header-sub-title">ยืนยันหมายเลขกรมธรรม์</span>
            </ModalTitleSection>

            <ModalBody className="modal-body-content" style={{ textAlign: 'center', margin: '30px 0 15px 0' }}>
              หมายเลขถูกใช้ไปแล้ว กรุณาเลือกหมายเลขอีกครั้ง
            </ModalBody>
            <ModalFooter style={{ justifyContent: 'center', borderTop: 0 }}>
              <Button color="primary" onClick={() => setUsedLuckyNumberModal(false)}>
                ยืนยัน
              </Button>
            </ModalFooter>
          </Modal>
        </>
      ) : (
        ''
      )}
    </>
  )
}

export default LuckyNumberRadioGroup
